import React from "react";
import BackBtn from "../components/BackBtn";
import SaveBadge from "../components/SaveBadge";
import { FF, T } from "../lib/constants";
import { buildCalendar, hasPlanning, mondayOf, parseISO, toISO, fmtRange, fmtDay } from "../lib/planning";

// Seizoensplanning van de club (vanaf editor): startdatum van week 1 en welke weken
// vakantie zijn. Wijzigingen worden meteen opgeslagen.
export default function Planning({ mob, pd, clubName, planning, lessonWeeks, onChange, onBack, sav }) {
  var p = planning || { start: "", off: {} };
  var planned = hasPlanning(p);
  var rows = planned ? buildCalendar(p, lessonWeeks) : [];
  var todayIso = toISO(mondayOf(new Date()));
  var offCount = rows.filter(function (r) { return r.off; }).length;
  var last = rows.length ? rows[rows.length - 1] : null;
  var startDate = planned ? parseISO(p.start) : null;

  function setStart(v) {
    if (!v) { onChange(Object.assign({}, p, { start: "" })); return; }
    var d = parseISO(v);
    if (!d) return;
    onChange(Object.assign({}, p, { start: toISO(mondayOf(d)) }));
  }
  function toggle(r) {
    var off = Object.assign({}, p.off || {});
    if (r.off) delete off[r.iso];
    else off[r.iso] = guessName(r.monday);
    onChange(Object.assign({}, p, { off: off }));
  }
  function rename(r, name) {
    var off = Object.assign({}, p.off || {});
    off[r.iso] = name;
    onChange(Object.assign({}, p, { off: off }));
  }

  var label = { fontSize: 11, fontWeight: 700, color: T.muted, textTransform: "uppercase", letterSpacing: 0.6 };

  return (
    <div style={{ maxWidth: 720, margin: "0 auto", padding: "12px " + pd + "px 48px", fontFamily: FF }}>
      <SaveBadge show={sav} />
      <BackBtn label="Terug" onClick={onBack} />
      <h1 style={{ fontWeight: 800, fontSize: mob ? 24 : 28 }}>Seizoensplanning</h1>
      <p style={{ fontSize: 14, color: T.muted, marginTop: 4, marginBottom: 16, lineHeight: 1.5 }}>
        {"Geldt voor alle groepen van " + (clubName || "deze club") + ". Hiermee opent het weekoverzicht automatisch op de juiste week."}
      </p>

      <section style={{ background: T.card, border: "1px solid " + T.line2, borderRadius: 16, padding: 16, display: "flex", flexDirection: "column", gap: 8, marginBottom: 18 }}>
        <label htmlFor="sp-start" style={label}>Start van week 1</label>
        <input id="sp-start" type="date" value={p.start || ""} onChange={function (e) { setStart(e.target.value); }}
          style={{ height: 46, border: "1px solid " + T.line, borderRadius: 10, padding: "0 12px", fontSize: 16, fontWeight: 700, color: T.ink, background: T.soft, fontFamily: FF, maxWidth: 260 }} />
        {planned
          ? <p style={{ fontSize: 13, color: T.muted, lineHeight: 1.5 }}>
              {"Week 1 begint op maandag " + fmtDay(startDate) + ". " + lessonWeeks + " trainingsweken" + (offCount ? " en " + offCount + (offCount === 1 ? " vakantieweek" : " vakantieweken") : "") + (last ? "; de laatste les valt in de week van " + fmtDay(last.monday) + "." : ".")}
            </p>
          : <p style={{ fontSize: 13, color: T.muted, lineHeight: 1.5 }}>Kies de maandag waarop het seizoen begint. Zolang er geen startdatum is, opent het weekoverzicht op week 1.</p>}
      </section>

      {planned && (
        <>
          <div style={{ display: "flex", alignItems: "baseline", justifyContent: "space-between", gap: 12, marginBottom: 8, flexWrap: "wrap" }}>
            <h2 style={label}>Weken</h2>
            <span style={{ fontSize: 12, color: T.muted }}>Zet een week op "Vakantie" als er geen les is</span>
          </div>
          <div style={{ background: T.card, border: "1px solid " + T.line2, borderRadius: 16, overflow: "hidden" }}>
            {rows.map(function (r, i) {
              var isNow = r.iso === todayIso;
              return (
                <div key={r.iso} style={{ display: "flex", alignItems: "center", gap: 12, padding: "8px 14px", minHeight: 56, borderTop: i ? "1px solid #EFECE6" : "none", background: r.off ? "#FDF1E7" : "#fff" }}>
                  <div style={{ width: mob ? 96 : 150, flex: "none", fontSize: 13, color: T.muted }}>
                    {mob ? "ma " + fmtDay(r.monday) : fmtRange(r.monday)}
                    {isNow && <div style={{ fontSize: 11, fontWeight: 700, color: T.ink, marginTop: 2 }}>deze week</div>}
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    {r.off
                      ? <input aria-label={"Naam vakantie week van " + fmtDay(r.monday)} value={r.name} onChange={function (e) { rename(r, e.target.value); }}
                          style={{ width: "100%", height: 36, border: "1px solid #F3CDAE", borderRadius: 8, padding: "0 10px", fontSize: 14, fontWeight: 700, color: "#8A430D", background: "#fff", fontFamily: FF, boxSizing: "border-box" }} />
                      : <span style={{ fontSize: 15, fontWeight: 700, color: T.ink }}>{"Week " + r.week}</span>}
                  </div>
                  <button type="button" onClick={function () { toggle(r); }} aria-pressed={r.off}
                    style={{ flex: "none", height: 34, minWidth: 84, padding: "0 12px", borderRadius: 17, fontSize: 12, fontWeight: 700, fontFamily: FF, cursor: "pointer",
                      border: "1.5px solid " + (r.off ? "#B85A12" : T.line), background: r.off ? "#B85A12" : "#fff", color: r.off ? "#fff" : T.muted }}>
                    {r.off ? "Vakantie" : "Les"}
                  </button>
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}

// Voorstel voor een naam op basis van de maand (aan te passen in het invoerveld).
function guessName(monday) {
  var m = monday.getMonth();
  if (m === 9 || m === 10) return "Herfstvakantie";
  if (m === 11 || m === 0) return "Kerstvakantie";
  if (m === 1 || m === 2) return "Voorjaarsvakantie";
  if (m === 3 || m === 4) return "Meivakantie";
  if (m === 6 || m === 7) return "Zomervakantie";
  return "Geen les";
}
